/**
 * A buzz, where the phone can make one. `navigator.vibrate` is Android's; iOS
 * Safari has never shipped it, so there the setting is not even offered
 * (SettingsSheet) and every call here is a no-op.
 *
 * Kept to single short pulses. A card being picked up is a tick you barely
 * notice; anything longer than a couple of tens of milliseconds reads as a
 * notification, which is not what a card does.
 */
import { getSettings } from './settings'

export const canBuzz = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function'

/** Picking a card up: the lightest thing the motor can do. */
export const BUZZ_PICK = 6
/** Letting a card go onto the table. */
export const BUZZ_THROW = 14
/** Your turn has come round. */
export const BUZZ_TURN = 22

export function buzz(ms: number): void {
  if (!canBuzz || !getSettings().haptics) return
  try {
    navigator.vibrate(ms)
  } catch {
    /* a browser that exposes vibrate but refuses it (no user activation yet) */
  }
}
